var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.065,
    height: 160.945,
    viewBox: "0 0 153.065 160.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ccc;}.b{fill:#e6e6e6;}.c{fill:#fff;}.d{fill:#3f3d56;}.e{fill:#0f4b73;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.264 -1790)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23.264 1790)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M632.529,195.858a3.551,3.551,0,0,0-3.246-2.172H564.474a3.515,3.515,0,0,0-3.513,3.513v81.987a3.515,3.515,0,0,0,3.513,3.513h64.809a3.518,3.518,0,0,0,3.513-3.513V197.2A3.45,3.45,0,0,0,632.529,195.858Zm-.514,83.327a2.736,2.736,0,0,1-2.731,2.731H564.474a2.731,2.731,0,0,1-2.731-2.731h0V197.2a2.736,2.736,0,0,1,2.731-2.731h64.809a2.747,2.747,0,0,1,2.537,1.722,3.051,3.051,0,0,1,.1.308,2.709,2.709,0,0,1,.094.705Z",
    transform: "translate(-560.961 -193.686)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M644.3,224.154H624.775a1.562,1.562,0,1,1,0-3.123H644.3a1.562,1.562,0,1,1,0,3.124Z",
    transform: "translate(-586.254 -204.796)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M644.3,237.964H624.775a1.562,1.562,0,1,1,0-3.124H644.3a1.562,1.562,0,1,1,0,3.124Z",
    transform: "translate(-586.254 -210.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M598.011,234.04H583.742a1.758,1.758,0,0,1-1.757-1.757V215.449a1.759,1.759,0,0,1,1.757-1.757h14.268a1.759,1.759,0,0,1,1.757,1.757v16.834a1.759,1.759,0,0,1-1.757,1.757Z",
    transform: "translate(-569.503 -201.814)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M627.235,266.24H583.119a1.562,1.562,0,1,1,0-3.123h44.116a1.562,1.562,0,1,1,0,3.123Z",
    transform: "translate(-569.329 -221.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M627.235,280.054H583.119a1.562,1.562,0,1,1,0-3.123h44.116a1.562,1.562,0,1,1,0,3.123Z",
    transform: "translate(-569.329 -227.508)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M627.235,293.859H583.119a1.562,1.562,0,1,1,0-3.123h44.116a1.562,1.562,0,1,1,0,3.123Z",
    transform: "translate(-569.329 -233.117)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M627.235,307.672H583.119a1.562,1.562,0,1,1,0-3.123h44.116a1.562,1.562,0,1,1,0,3.123Z",
    transform: "translate(-569.329 -238.729)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M627.235,321.478H583.119a1.562,1.562,0,1,1,0-3.123h44.116a1.562,1.562,0,1,1,0,3.123Z",
    transform: "translate(-569.329 -244.339)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M685.192,276.994a4.512,4.512,0,0,0-4.126-2.761H598.7a4.467,4.467,0,0,0-4.465,4.465V382.892a4.467,4.467,0,0,0,4.465,4.465h82.364a4.47,4.47,0,0,0,4.465-4.465V278.7a4.382,4.382,0,0,0-.338-1.7Z",
    transform: "translate(-597.745 1563.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M682.111,384.994h-76.97c-1.109,0-1.978-1.215-1.978-2.762V285.577c0-1.549.87-2.762,1.978-2.762h76.97c1.11,0,1.978,1.215,1.978,2.762v96.654C684.088,383.78,683.219,384.994,682.111,384.994Z",
    transform: "translate(-601.371 1560.101)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M685.192,276.994a4.512,4.512,0,0,0-4.126-2.761H598.7a4.467,4.467,0,0,0-4.465,4.465V382.892a4.467,4.467,0,0,0,4.465,4.465h82.364a4.47,4.47,0,0,0,4.465-4.465V278.7a4.382,4.382,0,0,0-.338-1.7Zm-.653,105.9a3.477,3.477,0,0,1-3.473,3.473H598.7a3.474,3.474,0,0,1-3.473-3.471V278.7a3.478,3.478,0,0,1,3.473-3.473h82.364a3.49,3.49,0,0,1,3.224,2.185,3.863,3.863,0,0,1,.131.392,3.443,3.443,0,0,1,.119.9Z",
    transform: "translate(-597.745 1563.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M700.149,312.952H675.34a1.985,1.985,0,1,1,0-3.969h24.808a1.985,1.985,0,1,1,0,3.969Z",
    transform: "translate(-629.89 1549.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M700.149,330.5H675.34a1.985,1.985,0,1,1,0-3.969h24.808a1.985,1.985,0,0,1,0,3.969Z",
    transform: "translate(-629.89 1542.339)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M641.323,325.514h-18.13a2.235,2.235,0,0,1-2.233-2.233V301.886a2.235,2.235,0,0,1,2.233-2.233h18.13a2.235,2.235,0,0,1,2.233,2.233v21.395a2.235,2.235,0,0,1-2.233,2.233Z",
    transform: "translate(-608.602 1553.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M678.467,366.438H622.4a1.985,1.985,0,1,1,0-3.969h56.067a1.985,1.985,0,0,1,0,3.969Z",
    transform: "translate(-608.381 1527.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M678.463,383.988H622.4a1.985,1.985,0,0,1-.011-3.97h56.078a1.985,1.985,0,0,1,0,3.97Z",
    transform: "translate(-608.377 1520.608)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M678.467,401.538H622.4a1.985,1.985,0,1,1,0-3.97h56.067a1.985,1.985,0,1,1,.011,3.97Z",
    transform: "translate(-608.381 1513.477)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M678.463,419.088H622.4a1.985,1.985,0,0,1-.011-3.97h56.078a1.985,1.985,0,0,1,0,3.97Z",
    transform: "translate(-608.377 1506.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M678.463,436.638H622.4a1.985,1.985,0,1,1-.011-3.969h56.078a1.985,1.985,0,0,1,0,3.969Z",
    transform: "translate(-608.377 1499.216)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 32.06,
    cy: 32.06,
    r: 32.06,
    transform: "translate(129.801 1862.211) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M764.137,251V233.314h-9.109V251h-4.253l4.4,7.626,4.4,7.627,4.4-7.627,4.4-7.627Z",
    transform: "translate(856.829 2080.089) rotate(180)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature4);
export default __webpack_public_path__ + "static/media/feature4.71d0b5676c723c5529e0d613e70997ed.svg";
export { ForwardRef as ReactComponent };